import React from 'react';
import Styles from 'components/footer/Footer.module.scss';

const Footer = () => (
  <div className={Styles.footer}>
    <p className="mb-0 text-white fontTwenty font-weight-600 ">© 2022. All Rights Reserved.</p>
  </div>
);
export default Footer;
